import React from 'react';
import classNames from 'classnames';
import Text from '../text';
import { Flex } from '../box';
import Logo, { LogoProps } from './logo';

const PoweredByLogo = ({ className, variant = 'gray600', size, ...rest }: LogoProps): React.JSX.Element => (
  <Flex alignItems={'center'} className={classNames('box-powered-by-logo', className)} {...rest}>
    <Text marginRight={'xs'} size={'md'} variant={variant} marginTop={'none'} marginBottom={'xs'}>
      Powered by
    </Text>
    <Logo variant={variant} size={size} />
  </Flex>
);

export default PoweredByLogo;
